import * as React from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { useField } from "formik";
import HandleError from "../HandleError";

export default function TextFieldComponent({ name, ...props }) {
  const [field] = useField({ name, ...props });
  return (
    <Box
      sx={{
        height: "60px",
      }}
    >
      <TextField variant="standard" size="small" {...field} {...props} />
      <HandleError name={name} />
    </Box>
  );
}
